exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title_cell[data-v-f3ac064e]{padding:0 1px;background-color:transparent}[data-v-f3ac064e] .van-swipe__indicator{background-color:#1989fa}[data-v-f3ac064e] .van-swipe__indicators{bottom:5px}", ""]);

// exports
